import { useNavigate } from 'react-router-dom';
import { setModalDisclaimerActive, resetParams } from '../reducers/preferenceSlice';
import { resetSelectedBenchmarks as resetSelectedBenchmarksResumoCart } from '../reducers/resumoCartSlice';
import { resetSelectedBenchmarksPerfHist, resetCapaPDF } from '../';
import { cancelarAPI } from '../';
import { useAppDispatch } from '../reduxHooks';
/**
 * FunÃ§Ã£o para gerenciar estados ao realizar logout
 * @param hasDisclaimer Indica se usuÃ¡rio possui disclaimer ao abrir a aplicaÃ§Ã£o
 * @returns FunÃ§Ã£o de logout
 */
const useLogout = (hasDisclaimer) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const logout = () => {
        var _a, _b, _c, _d;
        window.localStorage.removeItem(`token-${(_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME) !== null && _b !== void 0 ? _b : 'comdinheiro'}`);
        window.localStorage.removeItem(`carteiraFavorita-${(_d = (_c = window.env) === null || _c === void 0 ? void 0 : _c.REACT_APP_NAME) !== null && _d !== void 0 ? _d : 'comdinheiro'}`);
        window.localStorage.removeItem("preferenceStyle");
        dispatch(resetParams());
        if (hasDisclaimer) {
            dispatch(setModalDisclaimerActive(true));
        }
        // resetar os benchmarks e capa de PDF customizada para carteira
        dispatch(resetSelectedBenchmarksResumoCart());
        dispatch(resetSelectedBenchmarksPerfHist());
        dispatch(resetCapaPDF());
        cancelarAPI();
        navigate('/login');
    };
    return logout;
};
export default useLogout;
